var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeNotstarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-2user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.313,
    height: 38.313,
    viewBox: "0 0 38.313 38.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H38.313V38.313H0Z",
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90825",
    "data-name": "Group 90825",
    transform: "translate(-1 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(6 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.583,0a7.576,7.576,0,0,0-.192,15.149,1.288,1.288,0,0,1,.351,0h.112A7.577,7.577,0,0,0,7.583,0Z",
    transform: "translate(6.266 6.274)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set-Filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cross-circle",
    d: "M588.745,1106.519a.868.868,0,1,1-1.225,1.229l-3.667-3.67-3.693,3.7a.874.874,0,0,1-1.234-1.238l3.693-3.7-3.667-3.661a.867.867,0,0,1,1.224-1.229l3.667,3.67,3.72-3.722a.874.874,0,0,1,1.233,1.238l-3.719,3.722,3.667,3.661Zm-4.9-17.519a13.849,13.849,0,1,0,13.849,13.849A13.847,13.847,0,0,0,583.849,1089Z",
    transform: "translate(-570 -1089)",
    fill: "#aeccc8",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNotstarted);
export default __webpack_public_path__ + "static/media/home-notstarted.d8445d30e1ce976bf6276c2ec49f3bd7.svg";
export { ForwardRef as ReactComponent };